import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Check } from 'lucide-react';
import { villaData } from '../data/mockData';

export const AmenitiesPage = () => {
  const amenityCategories = [
    {
      title: 'Otaqlar',
      items: ['3 yataq otağı', 'Geniş mətbəx', 'Söhbətgah / lounge', 'Balkon']
    },
    {
      title: 'Xarici İmkanlar',
      items: ['6x3.5 qızdırılan hovuz', 'Geniş meyvə bağı', 'Manqal sahəsi', 'Açıq havada böyük ekranlı kino']
    },
    {
      title: 'Mətbəx və Yemek',
      items: ['Mətbəx ləvazimatları', 'Samavar', 'Soyuducu', 'Qaz plitasi']
    },
    {
      title: 'Əyləncə',
      items: ['Karaoke seti', 'Kabel TV', 'Açıq havada kino sistemi (2.4 x 2.4m)']
    },
    {
      title: 'Rahatlıq',
      items: ['Kondisioner', 'Kombi sistemi', 'Su çəni', 'Qaz', 'İşıq']
    },
    {
      title: 'Digər',
      items: ['Tam təmirli', 'Əşyalı', 'Xüsusi özəl villa', 'Pulsuz parkinq']
    }
  ];
  
  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            İmkanlar və Xidmətlər
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Rahat və xatirələnəsi qalma üçün hər şey düşünülüb
          </p>
        </div>
        
        {/* Images Grid */}
        <div className="grid md:grid-cols-3 gap-4 mb-16">
          <img
            src={villaData.photos[3]}
            alt="Bedroom"
            className="rounded-xl shadow-lg h-64 w-full object-cover"
          />
          <img
            src={villaData.photos[1]}
            alt="Pool"
            className="rounded-xl shadow-lg h-64 w-full object-cover"
          />
          <img
            src={villaData.photos[0]}
            alt="Exterior"
            className="rounded-xl shadow-lg h-64 w-full object-cover"
          />
        </div>
        
        {/* Amenities Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {amenityCategories.map((category, index) => (
            <Card key={index} className="border-2 border-gray-100 hover:border-green-200 hover:shadow-lg transition-all duration-300">
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">{category.title}</h3>
                <ul className="space-y-3">
                  {category.items.map((item, idx) => (
                    <li key={idx} className="flex items-start space-x-3">
                      <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Check className="w-3 h-3 text-green-600" />
                      </div>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
        
        {/* Full Amenities List */}
        <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-2xl p-8 lg:p-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Tam İmkanlar Siyahısı
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {villaData.amenities.map((amenity, index) => (
              <div key={index} className="flex items-center space-x-3 bg-white p-3 rounded-lg">
                <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <Check className="w-4 h-4 text-white" />
                </div>
                <span className="text-gray-700">{amenity}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};